import { DimensionValue, ReportGridDimension } from '../types';

const months = ['Jan.', 'Fev.', 'Mar.', 'Abr.', 'Mai.', 'Jun.', 'Jul.', 'Ago.', 'Set.', 'Out.', 'Nov.', 'Dez.'];
const weekdays = ['Seg.', 'Ter.', 'Qua.', 'Qui.', 'Sex.', 'Sáb.', 'Dom.'];

/** Formata somente a apresentação; caminhos e filtros mantêm os valores originais. */
export function dimensionLabel(value: DimensionValue, dimension: ReportGridDimension): string {
  if (!dimension.key.includes('::') || typeof value !== 'number' || !Number.isInteger(value)) return String(value);
  const part = dimension.key.split('::').pop();
  if ((part === 'month' || part === 'mes') && value >= 1 && value <= 12) return months[value - 1];
  if ((part === 'quarter' || part === 'trimestre') && value >= 1 && value <= 4) return `${value}º Tri.`;
  if ((part === 'semester' || part === 'semestre') && value >= 1 && value <= 2) return `${value}º Sem.`;
  if (['week', 'week_sunday', 'semana', 'semana_domingo'].includes(part || '') && value >= 1 && value <= 54) return `${value}ª Sem.`;
  if ((part === 'weekday' || part === 'dia_semana') && value >= 1 && value <= 7) return weekdays[value - 1];
  if ((part === 'day' || part === 'dia') && value >= 1 && value <= 31) return `Dia ${value}`;
  if ((part === 'hour' || part === 'hora') && value >= 0 && value <= 23) return `${String(value).padStart(2, '0')}h`;
  if ((part === 'minute' || part === 'minuto') && value >= 0 && value <= 59) return `${String(value).padStart(2, '0')} min.`;
  if ((part === 'second' || part === 'segundo') && value >= 0 && value <= 59) return `${String(value).padStart(2, '0')} s`;
  return String(value);
}
